import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConsumerCategory } from '../models/consumer-category.model';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {standardRetry} from '@emm/core/util/rx.util';
import {Consumer} from '@emm/core/models/consumer.model';

@Injectable({ providedIn: 'root' })
export class ConsumerManagerService {

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}

    public getConsumerCategories(): Observable<ConsumerCategory[]> {

        return this.http.get(this.apiUrl + '/consumer-categories').pipe(
            map((response: ConsumerCategory[]) => response),
            standardRetry()
          );
      }

    public getConsumersForCategory(id: string): Observable<Consumer[]> {
        return this.http.get(`${this.apiUrl}/consumers?consumerCategory=${id}`).pipe(
            map((response: ConsumerCategory) => response),
            standardRetry()
        );
    }

    public getConsumers(id: string): Observable<any> {
        const url = `${this.apiUrl}/consumers`;
        return this.http.get(url).pipe(
            map((response: Consumer[]) => {
                return response.filter(c => c.consumerCategory === id);
            }),
            standardRetry()
          );
    }

    public getConsumerDetails(id: string): Observable<any> {
        const url = `${this.apiUrl}/consumers/${id}`;
        return this.http.get(url).pipe(standardRetry());
    }

    public createConsumerCategory(consumerCategory: ConsumerCategory): Observable<ConsumerCategory> {

        return this.http
        .post(`${this.apiUrl}/consumer-categories`, consumerCategory)
        .pipe(standardRetry());
    }

    public createConsumer(consumer: Consumer): Observable<Consumer> {

        return this.http
            .post(`${this.apiUrl}/consumers`, consumer).pipe(
                map(c => {
                    const newObject = {
                        deleted: false,
                        destinationType: c['destinationType'],
                        enabled: c['enabled'],
                        locked: c['locked'],
                        name: c['name'],
                        tag: c['tag'],
                        consumerCategory: c['consumerCategory'],
                        description: c['description']
                    };
                    return newObject;
                }),
                standardRetry()
            );
    }

    public deleteConsumer(consumerTag: string): Observable<object> {
        return this.http.delete(`${this.apiUrl}/consumers/${consumerTag}`).pipe(standardRetry());
    }

    public duplicateConsumer(oldConsumerTag: string, newConsumerTag: string, newConsumerName: string): Observable<Consumer> {
        const payload = {newConsumerTag, newConsumerName};
        return this.http.post(`${this.apiUrl}/consumers/${oldConsumerTag}`, payload).pipe(standardRetry());
    }

    public updateConsumer(consumerTag: string, updates: Consumer): Observable<object> {
        const payload = {...updates};
        return this.http.post(`${this.apiUrl}/consumers/update/${consumerTag}`, payload).pipe(standardRetry());
    }
}
